export const MockInvoiceTypeData = [
  {
    label: "Email hóa đơn tạo mới",
    value: "NEW_INVOICE_EMAIL_TEMPLATE",
  },
  {
    label: "Email hóa đơn tạo mới thông tư 78 (đã ký)",
    value: "NEW_INVOICE_EMAIL_TEMPLATE_CIRCULARS_78_SIGNED",
  },
  {
    label: "Email hóa đơn thay thế",
    value: "ALTERNATIVE_INVOICE_EMAIL_TEMPLATE",
  },
  {
    label: "Email hóa đơn điều chỉnh",
    value: "ADJUSTMENT_INVOICE_EMAIL_TEMPLATE",
  },
  {
    label: "Email hóa đơn xóa bỏ",
    value: "REMOVAL_INVOICE_EMAIL_TEMPLATE",
  }
];
